"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReportNavigationController", {
    enumerable: true,
    get: function() {
        return ReportNavigationController;
    }
});
const _errorMessage = require("../errorMessage");
const _graphconfig = require("../common/graph-config");
const _traceformatter = require("../trace-details-formatter/traceformatter");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
require("../window/window");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const weekInSeconds = 7 * 24 * 60 * 60;
const SECONDS_IN_DAY = 24 * 60 * 60;
let ReportNavigationController = class ReportNavigationController {
    hostConnected() {}
    async openReportForAnomalyIds(anomalies, newTab) {
        const idList = anomalies.map((a)=>a.id);
        if (newTab === undefined) {
            newTab = null;
        }
        // If only one anomaly is selected, open the report page using
        // the anomaly id directly.
        if (idList.length === 1) {
            const key = idList[0];
            const url = `/u/?anomalyIDs=${key}`;
            if (newTab) {
                newTab.location.href = url;
            } else {
                newTab = window.open(url, '_blank');
            }
            return !!newTab;
        }
        const idString = idList.join(',');
        const response = window.perf.fetch_anomalies_from_sql ? await this.fetchCreateShortcutApi(idString) : await this.fetchGroupReportApi(idString);
        if (!response) {
            if (newTab) newTab.close();
            // Return true to avoid triggering the "Popups blocked" error in the caller,
            // as the error was due to an API failure, not a blocked popup.
            return true;
        }
        const sid = response.sid || '';
        const url = sid ? `/u/?sid=${sid}` : `/u/?anomalyIDs=${encodeURIComponent(idString)}`;
        if (newTab) {
            newTab.location.href = url;
        } else {
            newTab = window.open(url, '_blank');
        }
        return !!newTab;
    }
    async openMultiGraphUrl(anomaly, newTab, isDryRun = false) {
        var _response;
        const response = await this.fetchGroupReportApi(String(anomaly.id));
        let timerangeMap = ((_response = response) === null || _response === void 0 ? void 0 : _response.timerange_map) || {};
        if (!timerangeMap[anomaly.id] && isDryRun) {
            const shiftResp = await this.fetchShiftApi(anomaly.start_revision, anomaly.end_revision);
            if (shiftResp) {
                timerangeMap = _object_spread_props(_object_spread({}, timerangeMap), {
                    [anomaly.id]: {
                        begin: shiftResp.begin,
                        end: shiftResp.end + SECONDS_IN_DAY
                    }
                });
            }
        }
        if (!timerangeMap[anomaly.id]) {
            console.warn('ReportNavigationController: timerange missing for anomaly', anomaly.id);
            if (newTab) newTab.close();
            return;
        }
        const urlList = await this.generateMultiGraphUrl([
            anomaly
        ], timerangeMap);
        this.openAnomalyUrl(urlList[0], newTab);
    }
    openAnomalyUrl(url, newTab) {
        if (!newTab || !url) {
            console.warn('Multi chart URL not found or tab was blocked.');
            if (newTab) newTab.close(); // Clean up the blank tab on failure.
            return;
        }
        // Navigate the already-opened tab to the final destination.
        newTab.location.href = url;
    }
    async fetchCreateShortcutApi(idString) {
        try {
            const response = await fetch('/_/anomalies/calculate_regr_shortcut', {
                method: 'POST',
                body: JSON.stringify({
                    anomalyIDs: idString
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return (0, _jsonOrThrow.jsonOrThrow)(response);
        } catch (msg) {
            (0, _errorMessage.errorMessage)(msg);
            return null;
        }
    }
    async fetchGroupReportApi(idString) {
        try {
            const response = await fetch('/_/anomalies/group_report', {
                method: 'POST',
                body: JSON.stringify({
                    anomalyIDs: idString
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return (0, _jsonOrThrow.jsonOrThrow)(response);
        } catch (msg) {
            (0, _errorMessage.errorMessage)(msg);
            return null;
        }
    }
    async fetchShiftApi(begin, end) {
        try {
            const response = await fetch('/_/shift', {
                method: 'POST',
                body: JSON.stringify({
                    begin: begin,
                    end: end
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return (0, _jsonOrThrow.jsonOrThrow)(response);
        } catch (msg) {
            (0, _errorMessage.errorMessage)('Failed to fetch shift data: ' + msg);
            return null;
        }
    }
    async generateMultiGraphUrl(anomalies, timerangeMap) {
        const shortcutUrlList = [];
        for(let i = 0; i < anomalies.length; i++){
            const timerange = this.calculateTimeRange(timerangeMap[anomalies[i].id]);
            const graphConfigs = [];
            const config = {
                keys: '',
                formulas: [],
                queries: []
            };
            config.queries = [
                this.traceFormatter.formatQuery(anomalies[i].test_path)
            ];
            graphConfigs.push(config);
            await (0, _graphconfig.updateShortcut)(graphConfigs).then((shortcut)=>{
                if (shortcut === '') {
                    this.shortcutUrl = '';
                    return;
                }
                this.shortcutUrl = shortcut;
            }).catch(_errorMessage.errorMessage);
            // request_type=0 only selects data points for within the range
            // rather than show 250 data points by default
            let url = `${window.location.protocol}//${window.location.host}` + `/m/?begin=${timerange[0]}&end=${timerange[1]}` + `&request_type=0&shortcut=${this.shortcutUrl}`;
            if (window.perf && window.perf.default_to_manual_plot_mode) {
                url += '&manual_plot_mode=true';
            }
            shortcutUrlList.push(url);
        }
        return shortcutUrlList;
    }
    calculateTimeRange(timerange) {
        if (!timerange) {
            return [
                '',
                ''
            ];
        }
        const timerangeBegin = timerange.begin;
        const timerangeEnd = timerange.end;
        // generate data one week ahead and one week behind to make it easier
        // for user to discern trends
        const newTimerangeBegin = timerangeBegin ? (timerangeBegin - weekInSeconds).toString() : '';
        const newTimerangeEnd = timerangeEnd ? (timerangeEnd + weekInSeconds).toString() : '';
        return [
            newTimerangeBegin,
            newTimerangeEnd
        ];
    }
    constructor(host){
        this.shortcutUrl = '';
        this.host = host;
        this.host.addController(this);
        this.traceFormatter = new _traceformatter.ChromeTraceFormatter();
    }
};
